import { Field } from "../types";
import { RenderSingleField } from "./renderSingleField";
import { useForm } from "../app/useForm";

export const RenderMultipleFields = (field: Field, index: number) => {
  const { label, fields, enables, name, value } = field;

  const { postData } = useForm();

  const conditionValue =
    (name as string) in postData ? postData[name as string] : value;

  let showChildren = false;
  if (enables && enables.children && conditionValue === true) {
    showChildren = true;
  }

  return (
    <div key={index}>
      <div className="grid grid-cols-2 border-b border-b-stone-100 py-4 dark:border-stone-900">
        <dt className="flex items-center truncate text-sm text-stone-900 dark:text-white">
          {label}
        </dt>
        {RenderSingleField(field)}
      </div>

      {showChildren &&
        fields?.map((field: Field, index: number) =>
          RenderMultipleFields(field, index),
        )}
    </div>
  );
};
